export const getShipmentPartnerList = state => {
    return state.list
}

export const getShipmentPartnerDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/shipmentPartner/getters.js